<template>
  <div>
    <p v-if="!dataavailable" style="font-size:2rem;margin-top:40vh">无需处理的数据NO DATA</p>
    <div v-for="x in collections" :key="x.label">
      <approval @hasdata="dataavailable=true" :tabletitle="x.label" :collection="x.value"></approval>
    </div>
  </div>
</template>


<script>
import approval from "./approval";
export default {
  components: { approval },


  data() {
    return {
      dataavailable:false,
      // collections: [
      //   { label: "材料使用日报", collection: "stock_out" },
      //   { label: "制作场日报", collection: "sitestatus_in" },
      //   { label: "进度日报", collection: "progress_out" },
      //   { label: "主材领用", collection: "material_out" },
      //   { label: "喷漆完成", collection: "material_in" },
      //   { label: "site progress", collection: "siteprogress_in" },
      //   //{title:"入库申请",collection:"stock_in"},
      //   //{title:"进度款申请",collection:"equipments_out"},
      // ]
    };
  },
  computed:{
    collections(){
      let thecollections=this.$store.state.collections.filter(obj=>{
        return obj.value.includes("_out")||obj.value.includes("_in")
      });
      return thecollections
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/received/received.vue